import { render, staticRenderFns } from "./Ckeditor.vue?vue&type=template&id=4ab9839f"
import script from "./Ckeditor.vue?vue&type=script&lang=js"
export * from "./Ckeditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports